import LinkedText from "../linkedText/linkedText.component";
import Tag from "../tag/tag.component";
import { ExampleViz } from "./components";
import type { ExampleCard } from "./dGrid.type";

interface DGridProps {
  cards: ExampleCard[];
}

// Worked-example cards (the preview's `.d-grid` of `.ex-card`s): a tag,
// a title, an illustration panel and a short explanation. Three across from
// `lg`; at `sm` two across with the last card spanning the full row.
const DGrid = ({ cards }: DGridProps) => (
  <div className="grid gap-6 sm:grid-cols-2 sm:[&>*:last-child:nth-child(odd)]:col-span-2 lg:grid-cols-3 lg:[&>*:last-child:nth-child(odd)]:col-span-1">
    {cards.map((card) => (
      <article
        key={card.title}
        className="flex flex-col gap-4 rounded-3xl border border-line bg-white p-6 sm:p-7"
      >
        <Tag>{card.tag}</Tag>
        <h3 className="text-[1.2rem] leading-snug font-bold tracking-[-0.01em]">
          {card.title}
        </h3>
        <ExampleViz blocks={card.viz} label={card.vizLabel} />
        <p className="text-[15.5px] leading-relaxed text-ink-muted">
          <LinkedText text={card.text} />
        </p>
      </article>
    ))}
  </div>
);

export default DGrid;
